import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface FeatureAllResponse {
  id: number;
  pid: number;
  feature_code: string;
  expire_time: number;
  is_expired: number;
}

export class FeatureAllData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("pid cannot be empty")
  @IsNumber("pid must be a number")
  pid: number;

  @Required("feature code cannot be empty")
  @IsString("feature code must be a string")
  featureCode: string;

  @Required("pid cannot be empty")
  @IsNumber("expire time must be a number")
  expireTime: number;

  @Required("is expired cannot be empty")
  @IsNumber("is expired must be a number")
  isExpired: number;
}

const transformAndValidateData = (
  response: FeatureAllResponse
): FeatureAllData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, FeatureAllData);
  } catch (error) {
    console.error("Feature all data validation failed:", error.message);
    throw error;
  }
};

/** 获取用户权益 */
export const featureAll = async (agentId?: string): Promise<FeatureAllData[]> => {
  const res = await api.post<FeatureAllResponse[]>('/feature/all', {}, agentId ? {
    headers: {
      'Team-Code': agentId || '',
    },
  } : {});
  const data = res.data.map(transformAndValidateData);
  return data;
}